// TanStack Query cache keys for admin matrix-stats.
import type { MatrixStatsPeriod } from "./api";

export const matrixStatsKeys = {
  all: ["admin", "matrix-stats"] as const,
  summary: (period: MatrixStatsPeriod) =>
    ["admin", "matrix-stats", period] as const,
};
